export class SimpleStore {
  constructor(opts = {}) {
    Object.assign(this, opts);
  }

  isFetching = false
  isRejected = false
  isFulfilled = false

  data = {}

  fetchData() {
    return Promise.resolve();
  }

  async tryFetchData() {
    if (!this.isFulfilled && !this.isFetching) {
      return await this.fetchData(...arguments);
    }
    return this.fetchPromise;
  }

  mergeFetched(handle) {
    return this.fetching(handle, true);
  }

  fetchPromise = null;
  async fetching(handle, autoMerge = false, isForce = false) {
    this.isFetching = true;
    if (!this.isFetching || !this.fetchPromise || isForce) {
      this.fetchPromise = typeof handle === 'function' ? handle() : handle;
    }

    try {
      const res = await this.fetchPromise;
      const newState = autoMerge ? (res.isResponse ? res.data : res) : void 0;
      Object.assign(this, {
        isFetching: false,
        isRejected: false,
        isFulfilled: true,
      }, newState);
      return res;
    } catch (err) {
      Object.assign(this, {
        isFetching: false,
        isRejected: true,
      });
      throw err;
    } finally {
      this.fetchPromise = null;
    }
  }
}
